const configuration = {
  BASE_URL:
    'https://geektrust.s3-ap-southeast-1.amazonaws.com/adminui-problem/members.json',
};

export default configuration;
